import { render, staticRenderFns } from "./comments-post-button.vue?vue&type=template&id=04a811a7&scoped=true&"
import script from "./comments-post-button.vue?vue&type=script&lang=js&"
export * from "./comments-post-button.vue?vue&type=script&lang=js&"
import style0 from "./comments-post-button.vue?vue&type=style&index=0&id=04a811a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a811a7",
  null
  
)

export default component.exports